import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import Benefits from './components/Benefits';
import Flow from './components/Flow';
import QRSection from './components/QRSection';
import FAQ from './components/FAQ';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import StickyButton from './components/StickyButton';

export default function HomePage() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 800);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <Hero />
      <Benefits />
      <Flow />
      <QRSection />
      <FAQ />
      <Footer />
      <StickyButton isVisible={isVisible} />
    </div>
  );
}
